
export const light = '#ffffff';
export const dark = '#000000';

// ! bg is determined by new grouping in CV-807
export const backgroundColors = {
    otherGroup: 'rgba(86, 138, 200, 0.3)',
    otherClinic: 'rgba(86, 138, 200, 0.6)',

    eventSingle: '#DBD233',
    eventTeam: '#fdab94',

    // semble: '#B256C8',
    // takeCare: '#B256C8',
    samble: '#D62755',
    takeCare: '#D62755',
    webdoc: '#D62755',

    freeWB: '#007500',
    freeInternal: '#4cc17f',

    visitOnline: '#3A3F56',
    // visitInPerson: '#d0234b',
    visitInPerson: '#A079CA',
    administrativeBooking: 'gray',
    defaultColor: '#60BEBB', // Removed - only keep to check if the color is used - which means that conditions are not ok
}

export function getTextColor(backgroundColor) {
    let r, g, b;

    if (backgroundColor === '#A079CA') {
        return light; // Special case for visitInPerson color
    }

    // Hex
    if (backgroundColor.startsWith('#')) {
        const hex = backgroundColor.replace('#', '');
        if (hex.length === 3) {
            r = parseInt(hex[0] + hex[0], 16);
            g = parseInt(hex[1] + hex[1], 16);
            b = parseInt(hex[2] + hex[2], 16);
        } else if (hex.length === 6) {
            r = parseInt(hex.substr(0, 2), 16);
            g = parseInt(hex.substr(2, 2), 16);
            b = parseInt(hex.substr(4, 2), 16);
        }
    }

    // RGBA or RGB
    else if (backgroundColor.startsWith('rgb')) {
        const parts = backgroundColor.match(/rgba?\((\d+), ?(\d+), ?(\d+)/i);
        if (parts) {
            r = parseInt(parts[1]);
            g = parseInt(parts[2]);
            b = parseInt(parts[3]);
        }
    }

    if (typeof r !== 'number' || typeof g !== 'number' || typeof b !== 'number') return light;

    const [nr, ng, nb] = [r, g, b].map(c => {
        const v = c / 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    const luminance = 0.2126 * nr + 0.7152 * ng + 0.0722 * nb;

    return luminance > 0.179 ? dark : light;
}

export function getBackgroundColorForEvent(event, selectedGroup, selectedClinic, templateColor) {
    if (!event || typeof event !== 'object') return 'transparent';

    let backgroundColor = backgroundColors.defaultColor;

    try {
        if (selectedGroup !== event?.group && (!event?.selectedEventDepartments || (event?.selectedEventDepartments && !event?.selectedEventDepartments?.includes(selectedClinic)))) {

            backgroundColor = backgroundColors.otherGroup;
        } else if (selectedClinic !== event?.clinic && (!event?.selectedEventDepartments || (event?.selectedEventDepartments && event?.selectedEventDepartments?.indexOf(selectedClinic) === -1))) {

            backgroundColor = backgroundColors.otherClinic;
        } else {
            if (event?.type === 'administrativeBooking') {
                backgroundColor = backgroundColors.administrativeBooking;
            } else if (event?.type === 'event') {
                backgroundColor = backgroundColors.eventSingle;
                if (event?.colleagues && Array.isArray(event.colleagues) && event.colleagues.length > 0) {
                    backgroundColor = backgroundColors.eventTeam;
                }
            } else if (['take-care', 'semble'].includes(event?.type)) {
                backgroundColor = backgroundColors.semble;
                if (event.type === 'take-care') backgroundColor = backgroundColors.takeCare;
            } else if (event.createOnWebDoc) {
                backgroundColor = backgroundColors.webdoc;
            } else if (event?.type === 'free') {
                backgroundColor = backgroundColors.freeWB;
                if (!event?.allActiveForms && (
                    !event?.eventForms ||
                    !Array.isArray(event?.eventForms) ||
                    event?.eventForms?.length <= 0
                )) {
                    backgroundColor = backgroundColors.freeInternal;
                }
            } else {
                if (event?.onlineVisit) {
                    backgroundColor = backgroundColors.visitOnline;
                } else {
                    backgroundColor = backgroundColors.visitInPerson;
                }
            }

            if (templateColor && typeof templateColor === 'string') {
                backgroundColor = templateColor;
            }
        }
    } catch (err) {
        console.error('Error in getBackgroundColorForEvent:', err);
    }

    return backgroundColor;
}

export function CalendarLegend({
    hasTakeCare,
    hasSemble,
    hasWebDoc,
    lang,
    isSchedule = false,
    isWholeClinic = false
}) {

    const config = {
        eventSingle: 'Event',
        eventTeam: 'Team event',
        visitInPerson: 'In-person visit',
        visitOnline: 'Online visit',
        freeWB: 'Availability - Web booking',
        freeInternal: 'Availability - Internal',
        semble: 'Event from Semble',
        takeCare: 'Event in Take Care Calendar',
        administrativeBooking: 'Administrative booking',
        otherClinic: 'Booking in another department',
        otherGroup: 'Booking in another clinic'
    }

    return <div className={`calendar-legend-wrap ${isSchedule ? 'calendar-legend-wrap-schedule' : isWholeClinic ? 'calendar-legend-wrap-whole-clinic' : 'calendar-legend-mobile'}`}>
        {Object.keys(config).map(key => {
            if (key === 'takeCare') return null;
            if (key === 'semble') return null;

            return <div
                className="legend-item"
                key={key}
            >
                <div
                    className="legend-color"
                    style={{ backgroundColor: backgroundColors[key] }}
                ></div>
                <h6>{config[key].translate(lang)}</h6>
            </div>
        })}
        {
            hasSemble || hasTakeCare || hasWebDoc ?
                <div
                    className="legend-item"
                    key='external-CV-807'
                >
                    <div
                        className="legend-color"
                        style={{ backgroundColor: "#D62755" }}
                    ></div>
                    <h6>{'Booking from external system'.translate(lang)}</h6>
                </div>
                :
                null
        }
    </div>
}